    <input type="text" id="kryptonite.zip" type="hidden">
    <input type="text" id="kryptonite.sign" type="hidden">

    <router-outlet></router-outlet>

    <app-sistema-carregando></app-sistema-carregando>

    <app-rodape class="alinhamentoRodape"></app-rodape>
